import store from '../store';
let dashboard = {
  _name: 'CSidebarNavItem',
  name: 'Dashboard',
  to: '/dashboard',
  icon: 'cil-speedometer',
  display : ["Admin", "subadmin", "Editor", "Viewer"]
};

let histograms = {
  _name: 'CSidebarNavDropdown',
  name: 'Histograms',
  icon: 'cil-graph',
  items :[
      {
        name : 'Mortality',
        to : '/histograms/mortality'
      },
      {
        name : 'Release',
        to : '/histograms/release'
      },
      {
        name : 'Outcome',
        to : '/histograms/outcome'
      },
      {
        name : 'Cause of Displacement',
        to : '/histograms/cause-of-displacement'
      },
      {
        name : 'Monthly',
        to : '/histograms/monthly'
      },
      {
        name : 'Yearly',
        to : '/histograms/yearly'
      },
      {
        name : 'Percentage',
        to : '/histograms/percentage'
      },

  ],
  display : ["Admin", "subadmin", "Editor", "Viewer"]
  // badge: {
  //   color: 'primary',
  //   text: 'NEW'
  // }
};

let speciesWise = {
  _name: 'CSidebarNavItem',
  name: 'Species Wise',
  icon: 'cil-paw',
  to : '/species-wise',
  display : ["Admin", "subadmin", "Editor", "Viewer"]
};

let existingCases = {
  _name: 'CSidebarNavItem',
  name : 'Existing Cases',
  to : '/existing-cases',
  icon: 'cil-list',
  display : ["Admin", "subadmin", "Editor", "Viewer"]
};

let incompleteCases = {
  _name: 'CSidebarNavItem',
  name : 'Incomplete Cases',
  to : '/incomplete-cases',
  icon: 'cil-list',
  display : ["Admin", "subadmin", "Editor",]
};

let exportCenter = {
  _name: 'CSidebarNavItem',
  name : 'Export Center',
  to : '/export-center',
  icon: 'cil-cloud-download',
  display : ["Admin", "subadmin", "Editor", "Viewer"]
};

let messageReport = {
  _name: 'CSidebarNavItem',
  name : 'SMS Report',
  to : '/message-report',
  icon: 'cil-comment-square',
  display : ["Admin", "subadmin"]
};

// let validationDashboard = {
//   _name: 'CSidebarNavItem',
//   name : 'Validation Dashboard',
//   to : '/validation-dashboard',
//   icon: 'cil-warning',
//   display : ["Admin", "subadmin", "Editor",]
// };

let rejectedCases = {
  _name: 'CSidebarNavItem',
  name : 'Rejected Cases',
  to : '/rejected-cases',
  icon: 'cil-x-circle',
  display : ["Admin", "subadmin", "Editor",]
};

let addCase = {
  _name: 'CSidebarNavItem',
  name : 'Add Case',
  to : '/add-new-case',
  icon: 'cil-clipboard',
  display : ["Admin", "subadmin", "Editor",]
};

let userAnalytics = {
  _name: 'CSidebarNavItem',
  name: 'User Analytics',
  to: '/user-analytics',
  icon: 'cil-graph',
  display : []
};

let users = {
  _name: 'CSidebarNavItem',
  name : 'Users',
  to : '/users',
  icon: 'cil-user-follow',
  display : ["Admin", "subadmin"]
}

let deletedUsers = {
  _name: 'CSidebarNavItem',
  name : 'Deleted Users',
  to : '/deleted-users',
  icon: 'cil-user-unfollow',
  display : ["Admin", "subadmin"]
}

let settings = {
  _name: 'CSidebarNavItem',
  name : 'Settings',
  to : '/settings',
  icon: 'cil-settings',
  display : ["Admin", "subadmin", "Editor", "Viewer"]
};

let speciesList = {
  _name: 'CSidebarNavItem',
  name : 'Update Species',
  to : '/species-list',
  icon: 'cil-paw',
  display : ["Admin", "subadmin", "Editor", "Viewer"]
}


let _children = [];

if(store.state.user.role == "Admin" || store.state.user.role == "subadmin"){
  _children = [
    dashboard,
    histograms,
    speciesWise,
    existingCases,
    incompleteCases,
    exportCenter,
    messageReport,
    // validationDashboard,
    rejectedCases,
    addCase,
    speciesList,
    users,
    deletedUsers,
    settings
  ]
}
else if(store.state.user.role == "Editor"){
  _children = [
    dashboard,
    histograms,
    speciesWise,
    existingCases,
    incompleteCases,
    exportCenter,
    // validationDashboard,
    rejectedCases,
    addCase,
    speciesList,
    settings
  ]
}
else if(store.state.user.role == "Viewer"){
  _children = [
    dashboard,
    histograms,
    speciesWise,
    existingCases,
    exportCenter,
    settings
  ]
}
else{
  _children = [
    dashboard,
    histograms,
    speciesWise,
  ]
}




export default [
  {
    _name: 'CSidebarNav',
    _children: _children
  }
]
